import '@mui/x-date-pickers/themeAugmentation'
import { Components, Theme } from '@mui/material'
import { ClockOMIcon } from '@omnea-app/icons'
import { DISABLED_OPACITY } from './disabledOpacity'

export const MuiTimePicker: Components<Omit<Theme, 'components'>>['MuiTimePicker'] = {
  defaultProps: {
    slots: { openPickerIcon: ClockOMIcon },
    slotProps: {
      // Leave 4px between the button and the field edge after the shared input padding.
      inputAdornment: { sx: { marginRight: -1 } },
      openPickerButton: {
        color: 'secondary',
        variant: 'ghost',
        size: 'small',
        sx: { marginY: -0.5 },
      },
      // Reuse the shared picker surface, without the calendar's bottom padding.
      desktopPaper: { sx: { paddingBottom: 0, overflow: 'hidden' } },
      actionBar: {
        actions: ['cancel', 'accept'],
      },
    },
  },
}

export const MuiMultiSectionDigitalClock: Components<Omit<Theme, 'components'>>['MuiMultiSectionDigitalClock'] = {
  styleOverrides: {
    root: { borderBottom: 0 },
  },
}

export const MuiMultiSectionDigitalClockSection: Components<Omit<Theme, 'components'>>['MuiMultiSectionDigitalClockSection'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: 52,
      maxHeight: 236,
      padding: theme.spacing(2),
      '&:not(:first-of-type)': {
        borderLeft: `${theme.strokeWidth.default}px solid ${theme.palette.border.subtle}`,
      },
    }),
    item: ({ theme }) => ({
      ...theme.typography['body-regular'],
      fontVariantNumeric: 'tabular-nums',
      width: 36,
      height: 36,
      minHeight: 36,
      padding: 0,
      margin: 0,
      borderRadius: theme.shape['radius-lg'],
      color: theme.palette.text.default,
      '&:first-of-type': { marginTop: 0 },
      '&:not(:last-child)': { marginBottom: theme.spacing(2.5) },
      '&:not(.Mui-disabled):hover, &.Mui-focusVisible': {
        backgroundColor: theme.palette.bg.interactive.hover,
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.bg.brand.default,
        color: theme.palette.text.brand.onBrand,
        '&:hover, &:focus-visible': {
          backgroundColor: theme.palette.bg.brand.hover,
        },
      },
      // Match other disabled menu items: apply opacity once to the normal text color.
      '&.Mui-disabled': { color: theme.palette.text.default, opacity: DISABLED_OPACITY },
    }),
  },
}
